import { render, staticRenderFns } from "./ModuleTypeHelp.vue?vue&type=template&id=2023ede0&"
import script from "./ModuleTypeHelp.vue?vue&type=script&lang=js&"
export * from "./ModuleTypeHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports